// extracted by mini-css-extract-plugin
export default {"title-progress":"BarraProgresso_title-progress__fbcAF","description-progress":"BarraProgresso_description-progress__lK3te"};